// Connection statuses
export const CONNECTION_OFFLINE = 0;
export const CONNECTION_ONLINE = 1;
export const CONNECTION_RECONNECTING = 2;
export const CONNECTION_FAILED = 3;
